const STORAGE_KEY = 'signup-attribution'

// Cookie de primeira parte gravado pelo GTM do site em `.api4com.com` — e por
// estar no dominio raiz que o `app.api4com.com` consegue le-lo. Guarda a
// atribuicao da visita ao www, que e a unica forma de o lead vindo de midia
// paga chegar aqui com origem quando a URL do signup vem sem UTM (link do
// vendedor pelo WhatsApp, ou endereco digitado).
const COOKIE_NAME = '_a4c_attr'

// Hora em que o lead clicou no botao de WhatsApp do site (TEL-2414). So existe
// para quem clicou, e e o que faz o n8n classificar o lead como WhatsApp em vez
// de Signup.
const WHATSAPP_CLICK_PARAM = 'wa_click_at'

const ATTRIBUTION_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'gclid'
]

const isFilledText = value => typeof value === 'string' && value.trim() !== ''

function pickAttribution (source) {
  const attribution = {}
  ATTRIBUTION_PARAMS.forEach(param => {
    if (isFilledText(source[param])) attribution[param] = source[param].trim()
  })
  return attribution
}

function readFromStorage () {
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!isFilledText(raw)) return {}
  try {
    return pickAttribution(JSON.parse(raw))
  } catch (_) {
    return {}
  }
}

// O cookie e escrito por outro time, no GTM do site: pode vir com formato
// inesperado, meio gravado ou bloqueado pelo navegador. Nada disso pode
// derrubar o cadastro, entao qualquer falha vira "sem atribuicao".
function readFromCookie () {
  try {
    const prefix = COOKIE_NAME + '='
    const entry = document.cookie
      .split(';')
      .map(item => item.trim())
      .find(item => item.indexOf(prefix) === 0)
    if (!entry) return {}
    const parsed = JSON.parse(decodeURIComponent(entry.slice(prefix.length)))
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (_) {
    return {}
  }
}

export default {
  resolve (query) {
    const cookie = readFromCookie()

    // Lead que passou pelo WhatsApp: as UTMs que valem sao as da visita que
    // levou ao clique, e nao as da URL do signup — o vendedor manda o link que
    // quiser, as vezes com UTM propria. Lendo as duas coisas do cookie, origem
    // e clique descrevem sempre a mesma jornada.
    if (isFilledText(cookie[WHATSAPP_CLICK_PARAM])) {
      const attribution = pickAttribution(cookie)
      attribution[WHATSAPP_CLICK_PARAM] = cookie[WHATSAPP_CLICK_PARAM].trim()
      return attribution
    }

    const fromQuery = pickAttribution(query)
    if (Object.keys(fromQuery).length > 0) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(fromQuery))
      return fromQuery
    }

    const fromStorage = readFromStorage()
    if (Object.keys(fromStorage).length > 0) return fromStorage

    // Sem UTM na URL e sem nada na sessao, o cookie ainda pode ter a origem da
    // visita ao site: e o caso de quem chega ao signup por link sem parametro.
    return pickAttribution(cookie)
  },

  // So a sessao e limpa. O cookie e do site, serve a outras medicoes e expira
  // sozinho; apaga-lo aqui tiraria do GTM um dado que nao e nosso.
  clear () {
    sessionStorage.removeItem(STORAGE_KEY)
  }
}



// WEBPACK FOOTER //
// ./src/services/signup-attribution.js